import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const CateringContent = ({ 
  title = "Kinder's Catering",
  subtitle = "Legendary BBQ. Served your way.",
  imageUrl = "/images/catering-hero.jpg",
  imageMobileUrl = null
}) => {
  const [currentImageUrl, setCurrentImageUrl] = useState(imageUrl);

  // Get the appropriate image URL based on device
  const getImageUrl = () => {
    // Check if we have mobile-specific image and we're on mobile
    const isMobile = window.innerWidth <= 768;
    if (isMobile && imageMobileUrl) {
      return imageMobileUrl;
    }
    
    return imageUrl;
  };

  // Update image URL on window resize
  useEffect(() => {
    const handleResize = () => {
      setCurrentImageUrl(getImageUrl());
    };

    // Set initial image
    setCurrentImageUrl(getImageUrl());

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [imageUrl, imageMobileUrl]);

  return (
    <div className="catering-hero-area">
      {/* Background Image Container */}
      <div 
        className="catering-background"
        style={{
          backgroundImage: `url(${currentImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          width: '100vw',
          height: '100vh', // 80% of viewport height as requested
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1,
        }}
      />
      
      {/* Content Container */}
      <div 
        className="catering-content-wrapper"
        style={{
          minHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          position: 'relative',
          zIndex: 1,
          padding: '2rem 0 4rem 0'
        }}
      >
        {/* Headlines Content */}
        <div className="catering-headlines is-flex is-flex-direction-column has-text-centered">
          {/* Main Title */}
          {title && (
            <div className="mb-4">
              <h1 className="title colorWhite">
                {title}
              </h1>
            </div>
          )}

          {/* Subtitle */}
          {subtitle && (
            <div className="mb-5">
              <h2 className="subtitle colorWhite">
                {subtitle}
              </h2>
            </div>
          )}

          {/* Optional CTA Button - you can uncomment and customize if needed */}
          
          <div className="catering-cta">
            <Link
              to="/catering/request-quote"
            >
              <button 
                className="button"
                style={{
                  padding: '1rem 2rem',
                  transition: 'all 0.2s ease-in-out',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--green-color)';
                  e.currentTarget.style.borderColor = 'var(--green-color)';
                  e.currentTarget.style.color = 'var(--black-color)';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--red-color)';
                  e.currentTarget.style.borderColor = 'var(--red-color)';
                  e.currentTarget.style.color = 'var(--white-color)';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                Request Catering Quote
              </button>
            </Link>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default CateringContent;